import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {switchMap, tap} from 'rxjs/operators';
import {ChangeUserBranchCommand, ChangeUserChainsCommand, CreateUserCommand, ResetPasswordCommand, User} from './users.model';
import {API_URL} from '../../environments/environment';
import {
  SNACKBAR_BRANCH_ADD_ERROR,
  SNACKBAR_BRANCH_CHANGE_SUCCESS,
  SNACKBAR_CHAIN_ADD_ERROR,
  SNACKBAR_CHAIN_ADD_SUCCESS,
  SNACKBAR_PASSWORD_RESET_ERROR,
  SNACKBAR_PASSWORD_RESET_SUCCESS
} from 'src/locale/consts.en';
import {MatSnackBar} from '@angular/material/snack-bar';
import {doc, onSnapshot} from 'firebase/firestore';
import {firestoreDb} from 'src/app/firebase';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private http = inject(HttpClient);
  private snackBar = inject(MatSnackBar);
  private db = firestoreDb;

  private servicemenBS$: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);
  servicemen$: Observable<User[]> = this.servicemenBS$.asObservable();

  getUserUuid(fbId: string): Observable<string> {
    return new Observable<string>((subscriber) => {
      const ref = doc(this.db, `usersClient/${fbId}`);

      return onSnapshot(
        ref,
        (snapshot) => {
          if (!snapshot.exists()) {
            subscriber.next('');
            return;
          }

          const data = snapshot.data() as { userId?: string };
          subscriber.next(data.userId ?? '');
        },
        (error) => subscriber.error(error)
      );
    });
  }
  getServiceman(): Observable<User[]> {
    return this.http.get<User[]>(API_URL + 'serviceman' )
      .pipe(
        tap( (srvms) => {
          const sortedUsrs = srvms.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
          this.servicemenBS$.next(sortedUsrs);
        } )
      );
  }

  getUserData(uuid: string): Observable<User> {
    return this.http.get<User>(API_URL + 'serviceman/' + uuid);
  }

  getBranchAdmins(): Observable<User[]> {
    return this.http.get<User[]>(API_URL + 'serviceman/branchadmin' );
  }



  resetUserPassword(cr: ResetPasswordCommand): Observable<boolean> {
    return this.http.post<ResetPasswordCommand>(API_URL + 'serviceman/reset', cr, {
      observe: 'response'
    }).pipe(
      switchMap((response: HttpResponse<ResetPasswordCommand>) => {
        if (response.status === 200 || response.status === 201) {
          this.snackBar.open(SNACKBAR_PASSWORD_RESET_SUCCESS, '', {duration: 2000, panelClass: 'app-snackbar-success'});
          return of(true);
        } else {
          this.snackBar.open(SNACKBAR_PASSWORD_RESET_ERROR, '', {duration: 2000, panelClass: 'app-snackbar-alert'});
          console.error('Error by changing team member by API');
          return of(false);
        }
      })
    );
  }
  addAdmin(serviceman: CreateUserCommand): Observable<boolean> {
    // new API method
    return this.http.post<CreateUserCommand>(API_URL + 'serviceman/create', serviceman, {
      observe: 'response'
    }).pipe(
      switchMap((response: HttpResponse<unknown>) => {
        if (response.status === 200 || response.status === 201) {
          console.log('Admin Created - response', response.body);
          return of(true);
        } else {
          console.error('Error by adding serviceman by API');
          return of(false);
        }
      })
    );
  }

  changeBranchForUser(cr: ChangeUserBranchCommand) {
    return this.http.post<ChangeUserBranchCommand>(API_URL + 'serviceman/changebranch', cr, {
      observe: 'response'
    }).pipe(
      switchMap((response: HttpResponse<unknown>) => {
        if (response.status === 200 || response.status === 201) {
          this.snackBar.open(SNACKBAR_BRANCH_CHANGE_SUCCESS, '', {duration: 2000, panelClass: 'app-snackbar-success'});
          console.log('Branch changed - response', response.body);
          return of(true);
        } else {
          this.snackBar.open(SNACKBAR_BRANCH_ADD_ERROR, '', {duration: 2000, panelClass: 'app-snackbar-alert'});
          console.error('Error when changing branch by API');
          return of(false);
        }
      })
    );
  }

  getChainAdmins(): Observable<User[]> {
    return this.http.get<User[]>(API_URL + 'serviceman/chainadmin' );
  }

  changeChainForUser(cr: ChangeUserChainsCommand) {
    return this.http.post<ChangeUserChainsCommand>(API_URL + 'serviceman/changechains', cr, {
      observe: 'response'
    }).pipe(
      switchMap((response: HttpResponse<unknown>) => {
        if (response.status === 200 || response.status === 201) {
          this.snackBar.open(SNACKBAR_CHAIN_ADD_SUCCESS, '', {duration: 2000, panelClass: 'app-snackbar-success'});
          console.log('Chains changed - response', response.body);
          return of(true);
        } else {
          this.snackBar.open(SNACKBAR_CHAIN_ADD_ERROR, '', {duration: 2000, panelClass: 'app-snackbar-alert'});
          console.error('Error when changing chains by API');
          return of(false);
        }
      })
    );
  }


}
